/** Translation key paths for the bus operator (transit) portal; texts live in assets/i18n. */
export const TRANSIT_KEYS = {
  nav: {
    dashboard: 'transit.nav.dashboard',
    vehicles: 'transit.nav.vehicles',
    drivers: 'transit.nav.drivers',
    routes: 'transit.nav.routes',
    shifts: 'transit.nav.shifts',
    cash: 'transit.nav.cash',
    fares: 'transit.nav.fares',
    reports: 'transit.nav.reports',
    wallet: 'transit.nav.wallet',
    settings: 'transit.nav.settings',
    logout: 'transit.nav.logout',
    map: 'transit.nav.map',
    integrations: 'transit.nav.integrations',
  },
  header: {
    defaultTitle: 'transit.header.defaultTitle',
    subtitle: 'transit.header.subtitle',
  },
  common: {
    refresh: 'transit.common.refresh',
    save: 'transit.common.save',
    cancel: 'transit.common.cancel',
    close: 'transit.common.close',
    edit: 'transit.common.edit',
    print: 'transit.common.print',
    copy: 'transit.common.copy',
    copied: 'transit.common.copied',
    exportCsv: 'transit.common.exportCsv',
    search: 'transit.common.search',
    all: 'transit.common.all',
    from: 'transit.common.from',
    to: 'transit.common.to',
    apply: 'transit.common.apply',
    previous: 'transit.common.previous',
    next: 'transit.common.next',
    pageOf: 'transit.common.pageOf',
    dash: 'transit.common.dash',
    required: 'transit.common.required',
    invalid: 'transit.common.invalid',
    loadError: 'transit.common.loadError',
    updated: 'transit.common.updated',
    filtersAria: 'transit.common.filtersAria',
    done: 'transit.common.done',
  },
  col: {
    bus: 'transit.col.bus',
    driver: 'transit.col.driver',
    route: 'transit.col.route',
    riders: 'transit.col.riders',
    card: 'transit.col.card',
    cash: 'transit.col.cash',
    total: 'transit.col.total',
    status: 'transit.col.status',
    actions: 'transit.col.actions',
    time: 'transit.col.time',
    amount: 'transit.col.amount',
    fare: 'transit.col.fare',
    method: 'transit.col.method',
    qty: 'transit.col.qty',
    pos: 'transit.col.pos',
    opened: 'transit.col.opened',
    closed: 'transit.col.closed',
    since: 'transit.col.since',
    date: 'transit.col.date',
  },
  enum: {
    walletOperation: {
      TRANSIT_TILL_SWEEP: 'transit.enum.walletOperation.TRANSIT_TILL_SWEEP',
      MTB_REQUEST: 'transit.enum.walletOperation.MTB_REQUEST',
      MTB_REQUEST_REVERSAL: 'transit.enum.walletOperation.MTB_REQUEST_REVERSAL',
      MTB: 'transit.enum.walletOperation.MTB',
      MTB_DV: 'transit.enum.walletOperation.MTB_DV',
      TRANSIT_FARE_REVERSAL: 'transit.enum.walletOperation.TRANSIT_FARE_REVERSAL',
      U2U: 'transit.enum.walletOperation.U2U',
      FEE: 'transit.enum.walletOperation.FEE',
      WA2TRANSIT: 'transit.enum.walletOperation.WA2TRANSIT',
      WALLET_TAP2TRANSIT: 'transit.enum.walletOperation.WALLET_TAP2TRANSIT',
      PT2TRANSIT: 'transit.enum.walletOperation.PT2TRANSIT',
      TOPUP: 'transit.enum.walletOperation.TOPUP',
      CASHOUT: 'transit.enum.walletOperation.CASHOUT',
    },
    counterpartyType: {
      TRANSIT_VEHICLE: 'transit.enum.counterpartyType.TRANSIT_VEHICLE',
      SYSTEM: 'transit.enum.counterpartyType.SYSTEM',
      SYSTEM_USER: 'transit.enum.counterpartyType.SYSTEM_USER',
      REGULAR_USER: 'transit.enum.counterpartyType.REGULAR_USER',
      SERVICE_PROVIDER: 'transit.enum.counterpartyType.SERVICE_PROVIDER',
      STORE: 'transit.enum.counterpartyType.STORE',
      PAYMENT_TAG: 'transit.enum.counterpartyType.PAYMENT_TAG',
      PAYMENT_GATEWAY: 'transit.enum.counterpartyType.PAYMENT_GATEWAY',
      ONE_PAY: 'transit.enum.counterpartyType.ONE_PAY',
      REDEMPTION_POINT: 'transit.enum.counterpartyType.REDEMPTION_POINT',
    },
    shiftStatus: {
      OPEN: 'transit.enum.shiftStatus.OPEN',
      CLOSED: 'transit.enum.shiftStatus.CLOSED',
    },
    closeReason: {
      DRIVER: 'transit.enum.closeReason.DRIVER',
      HANDOVER: 'transit.enum.closeReason.HANDOVER',
      MOVED: 'transit.enum.closeReason.MOVED',
      IDLE: 'transit.enum.closeReason.IDLE',
      OFFICE: 'transit.enum.closeReason.OFFICE',
      DEACTIVATED: 'transit.enum.closeReason.DEACTIVATED',
    },
    fareMethod: {
      CARD: 'transit.enum.fareMethod.CARD',
      CASH: 'transit.enum.fareMethod.CASH',
      PHONE: 'transit.enum.fareMethod.PHONE',
      WHATSAPP: 'transit.enum.fareMethod.WHATSAPP',
      SMS: 'transit.enum.fareMethod.SMS',
      VOUCHER: 'transit.enum.fareMethod.VOUCHER',
    },
    fareStatus: {
      APPROVED: 'transit.enum.fareStatus.APPROVED',
      DECLINED: 'transit.enum.fareStatus.DECLINED',
      UNPAID: 'transit.enum.fareStatus.UNPAID',
      VOIDED: 'transit.enum.fareStatus.VOIDED',
    },
    declineReason: {
      UNKNOWN_CARD: 'transit.enum.declineReason.UNKNOWN_CARD',
      CARD_INACTIVE: 'transit.enum.declineReason.CARD_INACTIVE',
      LOW_BALANCE: 'transit.enum.declineReason.LOW_BALANCE',
      CARD_BLOCKED_DEBT: 'transit.enum.declineReason.CARD_BLOCKED_DEBT',
      CURRENCY_MISMATCH: 'transit.enum.declineReason.CURRENCY_MISMATCH',
      WALLET_INACTIVE: 'transit.enum.declineReason.WALLET_INACTIVE',
    },
    cashStatus: {
      PENDING: 'transit.enum.cashStatus.PENDING',
      RECEIVED: 'transit.enum.cashStatus.RECEIVED',
      SHORT: 'transit.enum.cashStatus.SHORT',
      OVER: 'transit.enum.cashStatus.OVER',
    },
    activeStatus: {
      ACTIVE: 'transit.enum.activeStatus.ACTIVE',
      INACTIVE: 'transit.enum.activeStatus.INACTIVE',
    },
    groupBy: {
      day: 'transit.enum.groupBy.day',
      vehicle: 'transit.enum.groupBy.vehicle',
      driver: 'transit.enum.groupBy.driver',
      route: 'transit.enum.groupBy.route',
      fareOption: 'transit.enum.groupBy.fareOption',
      method: 'transit.enum.groupBy.method',
    },
    deliveryStatus: {
      SENT: 'transit.enum.deliveryStatus.SENT',
      FAILED: 'transit.enum.deliveryStatus.FAILED',
      SENDING: 'transit.enum.deliveryStatus.SENDING',
    },
    signInMethod: {
      CODE: 'transit.enum.signInMethod.CODE',
      CARD: 'transit.enum.signInMethod.CARD',
    },
  },
  dashboard: {
    title: 'transit.dashboard.title',
    lead: 'transit.dashboard.lead',
    riders: 'transit.dashboard.riders',
    revenue: 'transit.dashboard.revenue',
    revenueMeta: 'transit.dashboard.revenueMeta',
    onRoad: 'transit.dashboard.onRoad',
    onRoadMeta: 'transit.dashboard.onRoadMeta',
    parked: 'transit.dashboard.parked',
    parkedMeta: 'transit.dashboard.parkedMeta',
    offline: 'transit.dashboard.offline',
    offlineMeta: 'transit.dashboard.offlineMeta',
    pendingCash: 'transit.dashboard.pendingCash',
    wallet: 'transit.dashboard.wallet',
    tills: 'transit.dashboard.tills',
    tillsMeta: 'transit.dashboard.tillsMeta',
    liveTitle: 'transit.dashboard.liveTitle',
    noneLive: 'transit.dashboard.noneLive',
  },
  vehicles: {
    title: 'transit.vehicles.title',
    lead: 'transit.vehicles.lead',
    add: 'transit.vehicles.add',
    addTitle: 'transit.vehicles.addTitle',
    editTitle: 'transit.vehicles.editTitle',
    fleetNumber: 'transit.vehicles.fleetNumber',
    fleetHint: 'transit.vehicles.fleetHint',
    plate: 'transit.vehicles.plate',
    till: 'transit.vehicles.till',
    noPos: 'transit.vehicles.noPos',
    online: 'transit.vehicles.online',
    offlineSince: 'transit.vehicles.offlineSince',
    neverSeen: 'transit.vehicles.neverSeen',
    battery: 'transit.vehicles.battery',
    activatePos: 'transit.vehicles.activatePos',
    replacePos: 'transit.vehicles.replacePos',
    disablePos: 'transit.vehicles.disablePos',
    movePos: 'transit.vehicles.movePos',
    deactivateBus: 'transit.vehicles.deactivateBus',
    activateBus: 'transit.vehicles.activateBus',
    onShift: 'transit.vehicles.onShift',
    noShift: 'transit.vehicles.noShift',
    empty: 'transit.vehicles.empty',
    codeTitle: 'transit.vehicles.codeTitle',
    codeSteps: 'transit.vehicles.codeSteps',
    codeReplaceNote: 'transit.vehicles.codeReplaceNote',
    codeExpires: 'transit.vehicles.codeExpires',
    codeExpired: 'transit.vehicles.codeExpired',
    newCode: 'transit.vehicles.newCode',
    confirmDisablePos: 'transit.vehicles.confirmDisablePos',
    confirmDeactivateBus: 'transit.vehicles.confirmDeactivateBus',
    moveTitle: 'transit.vehicles.moveTitle',
    moveTo: 'transit.vehicles.moveTo',
    moveHint: 'transit.vehicles.moveHint',
    toastAdded: 'transit.vehicles.toastAdded',
    toastSaved: 'transit.vehicles.toastSaved',
    toastDisabled: 'transit.vehicles.toastDisabled',
    toastMoved: 'transit.vehicles.toastMoved',
    posConnected: 'transit.vehicles.posConnected',
    colWhatsapp: 'transit.vehicles.colWhatsapp',
    waEnable: 'transit.vehicles.waEnable',
    waChange: 'transit.vehicles.waChange',
    waRemove: 'transit.vehicles.waRemove',
    waRemoveConfirm: 'transit.vehicles.waRemoveConfirm',
    waTitle: 'transit.vehicles.waTitle',
    waCode: 'transit.vehicles.waCode',
    waHint: 'transit.vehicles.waHint',
    waAuto: 'transit.vehicles.waAuto',
    waAll: 'transit.vehicles.waAll',
    waAllDone: 'transit.vehicles.waAllDone',
    stickers: 'transit.vehicles.stickers',
    noStickers: 'transit.vehicles.noStickers',
    stickerTitle: 'transit.vehicles.stickerTitle',
    stickerSend: 'transit.vehicles.stickerSend',
    stickerExample: 'transit.vehicles.stickerExample',
    stickerNumber: 'transit.vehicles.stickerNumber',
    stickerScan: 'transit.vehicles.stickerScan',
    stickerBus: 'transit.vehicles.stickerBus',
    map: 'transit.vehicles.map',
  },
  drivers: {
    title: 'transit.drivers.title',
    lead: 'transit.drivers.lead',
    add: 'transit.drivers.add',
    import: 'transit.drivers.import',
    searchPlaceholder: 'transit.drivers.searchPlaceholder',
    colName: 'transit.drivers.colName',
    colMobile: 'transit.drivers.colMobile',
    colCode: 'transit.drivers.colCode',
    colOnShift: 'transit.drivers.colOnShift',
    colLastShift: 'transit.drivers.colLastShift',
    onBus: 'transit.drivers.onBus',
    newCode: 'transit.drivers.newCode',
    newCodesAll: 'transit.drivers.newCodesAll',
    newCodesAllConfirm: 'transit.drivers.newCodesAllConfirm',
    newCodesAllTitle: 'transit.drivers.newCodesAllTitle',
    newCodesAllNote: 'transit.drivers.newCodesAllNote',
    newCodesAllDone: 'transit.drivers.newCodesAllDone',
    codeOutdated: 'transit.drivers.codeOutdated',
    outdatedBanner: 'transit.drivers.outdatedBanner',
    deactivate: 'transit.drivers.deactivate',
    activate: 'transit.drivers.activate',
    addTitle: 'transit.drivers.addTitle',
    editTitle: 'transit.drivers.editTitle',
    name: 'transit.drivers.name',
    mobile: 'transit.drivers.mobile',
    mobileHint: 'transit.drivers.mobileHint',
    codeTitle: 'transit.drivers.codeTitle',
    codeNote: 'transit.drivers.codeNote',
    confirmNewCode: 'transit.drivers.confirmNewCode',
    confirmDeactivate: 'transit.drivers.confirmDeactivate',
    importTitle: 'transit.drivers.importTitle',
    importHint: 'transit.drivers.importHint',
    importRun: 'transit.drivers.importRun',
    importDone: 'transit.drivers.importDone',
    importErrors: 'transit.drivers.importErrors',
    importRow: 'transit.drivers.importRow',
    printCodes: 'transit.drivers.printCodes',
    printCardTitle: 'transit.drivers.printCardTitle',
    printCardNote: 'transit.drivers.printCardNote',
    toastAdded: 'transit.drivers.toastAdded',
    toastSaved: 'transit.drivers.toastSaved',
    toastDeactivated: 'transit.drivers.toastDeactivated',
    toastActivated: 'transit.drivers.toastActivated',
    empty: 'transit.drivers.empty',
    importPlaceholder: 'transit.drivers.importPlaceholder',
    importCount: 'transit.drivers.importCount',
    card: 'transit.drivers.card',
    cardLinked: 'transit.drivers.cardLinked',
    cardNone: 'transit.drivers.cardNone',
    unlinkCard: 'transit.drivers.unlinkCard',
    unlinkConfirm: 'transit.drivers.unlinkConfirm',
    cardHowTo: 'transit.drivers.cardHowTo',
  },
  routes: {
    title: 'transit.routes.title',
    lead: 'transit.routes.lead',
    addRoute: 'transit.routes.addRoute',
    editRoute: 'transit.routes.editRoute',
    code: 'transit.routes.code',
    codeHint: 'transit.routes.codeHint',
    nameAr: 'transit.routes.nameAr',
    nameEn: 'transit.routes.nameEn',
    addFare: 'transit.routes.addFare',
    editFare: 'transit.routes.editFare',
    labelAr: 'transit.routes.labelAr',
    labelEn: 'transit.routes.labelEn',
    amount: 'transit.routes.amount',
    colour: 'transit.routes.colour',
    sortOrder: 'transit.routes.sortOrder',
    activeFare: 'transit.routes.activeFare',
    hidden: 'transit.routes.hidden',
    preview: 'transit.routes.preview',
    noFares: 'transit.routes.noFares',
    empty: 'transit.routes.empty',
    priceNote: 'transit.routes.priceNote',
    toastSaved: 'transit.routes.toastSaved',
  },
  shifts: {
    title: 'transit.shifts.title',
    lead: 'transit.shifts.lead',
    allBuses: 'transit.shifts.allBuses',
    report: 'transit.shifts.report',
    endShift: 'transit.shifts.endShift',
    confirmEnd: 'transit.shifts.confirmEnd',
    zTitle: 'transit.shifts.zTitle',
    zReason: 'transit.shifts.zReason',
    zByFare: 'transit.shifts.zByFare',
    zTotal: 'transit.shifts.zTotal',
    zSwept: 'transit.shifts.zSwept',
    empty: 'transit.shifts.empty',
    toastEnded: 'transit.shifts.toastEnded',
  },
  cash: {
    title: 'transit.cash.title',
    lead: 'transit.cash.lead',
    filterPending: 'transit.cash.filterPending',
    totalPending: 'transit.cash.totalPending',
    colExpected: 'transit.cash.colExpected',
    colCounted: 'transit.cash.colCounted',
    colDiff: 'transit.cash.colDiff',
    receive: 'transit.cash.receive',
    receiveTitle: 'transit.cash.receiveTitle',
    expected: 'transit.cash.expected',
    counted: 'transit.cash.counted',
    note: 'transit.cash.note',
    diffPreview: 'transit.cash.diffPreview',
    empty: 'transit.cash.empty',
    toastReceived: 'transit.cash.toastReceived',
  },
  fares: {
    title: 'transit.fares.title',
    lead: 'transit.fares.lead',
    refund: 'transit.fares.refund',
    refundTitle: 'transit.fares.refundTitle',
    refundNote: 'transit.fares.refundNote',
    reason: 'transit.fares.reason',
    count: 'transit.fares.count',
    empty: 'transit.fares.empty',
    toastRefunded: 'transit.fares.toastRefunded',
    payer: 'transit.fares.payer',
    fee: 'transit.fares.fee',
    voucherNoRefund: 'transit.fares.voucherNoRefund',
  },
  reports: {
    title: 'transit.reports.title',
    lead: 'transit.reports.lead',
    groupBy: 'transit.reports.groupBy',
    today: 'transit.reports.today',
    yesterday: 'transit.reports.yesterday',
    last7: 'transit.reports.last7',
    thisMonth: 'transit.reports.thisMonth',
    colFares: 'transit.reports.colFares',
    empty: 'transit.reports.empty',
    note: 'transit.reports.note',
  },
  wallet: {
    title: 'transit.wallet.title',
    lead: 'transit.wallet.lead',
    balance: 'transit.wallet.balance',
    transactionsTitle: 'transit.wallet.transactionsTitle',
    colType: 'transit.wallet.colType',
    colDirection: 'transit.wallet.colDirection',
    colCounterparty: 'transit.wallet.colCounterparty',
    colFee: 'transit.wallet.colFee',
    colNet: 'transit.wallet.colNet',
    colBalance: 'transit.wallet.colBalance',
    type: 'transit.wallet.type',
    direction: 'transit.wallet.direction',
    in: 'transit.wallet.in',
    out: 'transit.wallet.out',
    empty: 'transit.wallet.empty',
  },
  settings: {
    title: 'transit.settings.title',
    lead: 'transit.settings.lead',
    cashAllowed: 'transit.settings.cashAllowed',
    cashAllowedHint: 'transit.settings.cashAllowedHint',
    cardAllowed: 'transit.settings.cardAllowed',
    cardAllowedHint: 'transit.settings.cardAllowedHint',
    cardOn: 'transit.settings.cardOn',
    cardOff: 'transit.settings.cardOff',
    idleHours: 'transit.settings.idleHours',
    idleHoursHint: 'transit.settings.idleHoursHint',
    voidWindow: 'transit.settings.voidWindow',
    voidWindowHint: 'transit.settings.voidWindowHint',
    driverUndo: 'transit.settings.driverUndo',
    driverUndoHint: 'transit.settings.driverUndoHint',
    timezone: 'transit.settings.timezone',
    erp: 'transit.settings.erp',
    erpHint: 'transit.settings.erpHint',
    currency: 'transit.settings.currency',
    signIn: 'transit.settings.signIn',
    signInCode: 'transit.settings.signInCode',
    configVersion: 'transit.settings.configVersion',
    toastSaved: 'transit.settings.toastSaved',
    signInHint: 'transit.settings.signInHint',
    erpMoved: 'transit.settings.erpMoved',
  },
  errors: {
    transit_mobileTaken: 'transit.errors.transit_mobileTaken',
    transit_driverCodesExhausted: 'transit.errors.transit_driverCodesExhausted',
    invalidRequestParameter: 'transit.errors.invalidRequestParameter',
    generic: 'transit.errors.generic',
  },
  map: {
    title: 'transit.map.title',
    lead: 'transit.map.lead',
    online: 'transit.map.online',
    offline: 'transit.map.offline',
    parked: 'transit.map.parked',
    onShift: 'transit.map.onShift',
    fixAt: 'transit.map.fixAt',
    battery: 'transit.map.battery',
    noPosition: 'transit.map.noPosition',
    empty: 'transit.map.empty',
    stale: 'transit.map.stale',
    list: 'transit.map.list',
  },
  integrations: {
    title: 'transit.integrations.title',
    lead: 'transit.integrations.lead',
    emailTitle: 'transit.integrations.emailTitle',
    emailLead: 'transit.integrations.emailLead',
    emailLabel: 'transit.integrations.emailLabel',
    emailHint: 'transit.integrations.emailHint',
    emailSave: 'transit.integrations.emailSave',
    sendNow: 'transit.integrations.sendNow',
    sendDay: 'transit.integrations.sendDay',
    sentToast: 'transit.integrations.sentToast',
    deliveries: 'transit.integrations.deliveries',
    noDeliveries: 'transit.integrations.noDeliveries',
    journalTitle: 'transit.integrations.journalTitle',
    journalLead: 'transit.integrations.journalLead',
    accountCode: 'transit.integrations.accountCode',
    saveAccounts: 'transit.integrations.saveAccounts',
    preview: 'transit.integrations.preview',
    download: 'transit.integrations.download',
    colDate: 'transit.integrations.colDate',
    colAccount: 'transit.integrations.colAccount',
    colDebit: 'transit.integrations.colDebit',
    colCredit: 'transit.integrations.colCredit',
    colRef: 'transit.integrations.colRef',
    colDesc: 'transit.integrations.colDesc',
    totals: 'transit.integrations.totals',
    balanced: 'transit.integrations.balanced',
    unbalanced: 'transit.integrations.unbalanced',
    noLines: 'transit.integrations.noLines',
    accounts: {
      fareRevenue: 'transit.integrations.accounts.fareRevenue',
      lycheeWallet: 'transit.integrations.accounts.lycheeWallet',
      paymentFees: 'transit.integrations.accounts.paymentFees',
      cashWithDrivers: 'transit.integrations.accounts.cashWithDrivers',
      cashOffice: 'transit.integrations.accounts.cashOffice',
      cashShortage: 'transit.integrations.accounts.cashShortage',
      cashOverage: 'transit.integrations.accounts.cashOverage',
    },
    apiTitle: 'transit.integrations.apiTitle',
    apiLead: 'transit.integrations.apiLead',
    keyName: 'transit.integrations.keyName',
    keyNamePlaceholder: 'transit.integrations.keyNamePlaceholder',
    createKey: 'transit.integrations.createKey',
    keyCreatedTitle: 'transit.integrations.keyCreatedTitle',
    keyCreatedNote: 'transit.integrations.keyCreatedNote',
    colKey: 'transit.integrations.colKey',
    colCreated: 'transit.integrations.colCreated',
    colLastUsed: 'transit.integrations.colLastUsed',
    never: 'transit.integrations.never',
    revoke: 'transit.integrations.revoke',
    revokeConfirm: 'transit.integrations.revokeConfirm',
    revoked: 'transit.integrations.revoked',
    active: 'transit.integrations.active',
    noKeys: 'transit.integrations.noKeys',
    endpoints: 'transit.integrations.endpoints',
    headerNote: 'transit.integrations.headerNote',
  },
} as const;
